import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { ContactForm } from './ContactForm';
import { useSendContactMessage } from '../../hooks/api/use-contact.hook';

export const Contact = () => {
  const navigate = useNavigate();
  const [sendContactMessage, { error, loading }] = useSendContactMessage();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = useForm<ContactForm>({ resolver: classValidatorResolver(ContactForm) });

  const onSubmit: SubmitHandler<ContactForm> = async (values) => {
    await sendContactMessage(values);
  };

  const renderContent = () => {
    if (isSubmitSuccessful) {
      return <Alert severity="success">Message sent</Alert>;
    }

    return (
      <>
        <DialogContentText>Send a message to your designated system administrator.</DialogContentText>
        <TextField
          {...register('subject')}
          variant="outlined"
          sx={{ mt: '1rem' }}
          disabled={loading}
          error={Boolean(errors.subject)}
          helperText={errors.subject?.message}
          label="Subject"
          margin="dense"
          size="small"
          fullWidth
        />
        <TextField
          {...register('body')}
          variant="outlined"
          sx={{ mt: '1rem' }}
          disabled={loading}
          error={Boolean(errors.body)}
          helperText={errors.body?.message}
          label="Message"
          margin="dense"
          minRows={6}
          multiline
          fullWidth
        />
        {error ? (
          <Alert sx={{ mt: '1rem' }} severity="error">
            {error.response?.data.message}
          </Alert>
        ) : null}
      </>
    );
  };

  return (
    <Dialog open={true}>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: 600 }}>
        <DialogTitle>Contact</DialogTitle>
        <DialogContent>{renderContent()}</DialogContent>
        <DialogActions>
          <Button disabled={isSubmitting} variant="outlined" onClick={() => navigate('..')} color="primary">
            {isSubmitSuccessful ? 'Close' : 'Cancel'}
          </Button>
          {!isSubmitSuccessful ? (
            <LoadingButton color="primary" type="submit" variant="contained" loading={isSubmitting}>
              Send
            </LoadingButton>
          ) : null}
        </DialogActions>
      </form>
    </Dialog>
  );
};
